function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === 'function' ? title.call(vm) : title;
  }
};

export default {
  methods: {
    setPageTitle(overwrite = false) {
      const title = overwrite || getTitle(this);
      if (title) {
        document.title = title;
      }
    },
  },
  created() {
    this.setPageTitle();
  },
};
